import React from "react";
import {
  Button,
  TextField,
  Stack,
  CircularProgress,
  Box,
  Grid,
  Autocomplete,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useFormik } from "formik";
import { REPORTESDELEGADO } from "../../../graphql/reporteador";
import { useLazyQuery, useQuery } from "@apollo/client";
import Moment from "moment";
import { OBTENER_PERSONAS } from "../../../graphql/personas";
const FrmDelegadosReporte = ({ setDatos, setOpenDialog, setTitle }) => {
  const {
    data: personadata,
    loading: personaloading,
    error: personaerror,
  } = useQuery(OBTENER_PERSONAS);
  const [reportesDelegados, { loading, error, data }] =
    useLazyQuery(REPORTESDELEGADO);
  const formik = useFormik({
    initialValues: {
      fechaInicio: "",
      fechaFin: "",
      PersonaId: 0,
    },
    onSubmit: async (inputData) => {
      try {
        if (inputData.fechaInicio > inputData.fechaFin) {
          throw Error("La fecha de Inicio no puede ser mayor a la de Fin");
        }
        const datos = await reportesDelegados({
          variables: {
            entry: {
              fechaInicio: inputData.fechaInicio,
              fechaFin: inputData.fechaFin,
              PersonaId: parseInt(inputData.PersonaId),
            },
          },
        });

        setDatos(datos.data.reportesDelegados);
        setOpenDialog(false);
        setTitle(
          `Reporte de la fecha ${Moment(inputData.fechaInicio).format(
            "DD-MMMM-YYYY"
          )} a la fecha ${Moment(inputData.fechaFin).format("DD-MMMM-YYYY")}`
        );
      } catch (error) {
        console.log(error);
      }
    },
  });

  if (loading || personaloading)
    return (
      <>
        <Box sx={{ display: "flex" }}>
          <CircularProgress />
        </Box>
      </>
    );

  const { obtenerPersonas } = personadata;

  console.log(obtenerPersonas);

  //Call Information from the backend
  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container alignItems="flex-start" spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <Autocomplete
            fullWidth
            id="PersonaId"
            name="PersonaId"
            options={obtenerPersonas}
            getOptionLabel={(option) => option.nombre + " " + option.apellidos}
            onChange={(e, value) => {
              formik.setFieldValue("PersonaId", value.id);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name="PersonaId"
                label="Delegado"
                fullWidth
                variant="standard"
              />
            )}
          />
          {formik.errors.PersonaId}
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              onChange={(date) => formik.setFieldValue("fechaInicio", date)}
              value={formik.values.fechaInicio}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="fechaInicio"
                  fullWidth
                  variant="standard"
                  label="Fecha de Inicio"
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              onChange={(date) => formik.setFieldValue("fechaFin", date)}
              value={formik.values.fechaFin}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="fechaFin"
                  fullWidth
                  variant="standard"
                  label="Fecha de Fin"
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>

      <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
        <Button type="submit">Filtrar</Button>
        <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
      </Stack>
    </form>
  );
};

export default FrmDelegadosReporte;
